export default {
	computed: {
		pvr() {
			return this.item.pvr === true
		},
		pvrSet() {
			return this.item.pvr === true || this.item.pvr === false
		},
		pvrClass() {
			if (this.item.pvr === true) {
				return 'pvr_set'
			}
			if (this.item.pvr === false) {
				return 'pvr_set pvr_no'
			}
		},
		periodicPvr() {
			return this.item.periodic_pvr === true
		},
		periodicPvrSet() {
			return this.item.periodic_pvr === true || this.item.periodic_pvr === false
		},
		periodicPvrClass() {
			if (this.item.periodic_pvr === true) {
				return 'periodic_rec_set'
			}
			if (this.item.periodic_pvr === false) {
				return 'periodic_rec_set periodic_rec_no'
			}
		},
		catchup() {
			return this.item.catchup === true
		},
		catchupHours() {
			return this.item.catchup_hours
		},
		timeshiftSet() {
			return this.item.timeshift === true || this.item.timeshift === false
		},
		timeshiftClass() {
			if (this.item.timeshift === true) {
				return 'timeshift_set'
			}
			if (this.item.timeshift === false) {
				return 'timeshift_set timeshift_no'
			}
		},
		timeshiftTitle() {
			if (this.item.timeshift === true) {
				return this.$gettext('Timeshift povolen')
			}
			if (this.item.timeshift === false) {
				return this.$gettext('Timeshift zakázán')
			}
		}
	}
}



// WEBPACK FOOTER //
// ./src/components/mixins/nonlinear-settings-info.js